import type { ReactNode } from "react";

/**
 * L'état vide, et il dit QUOI FAIRE.
 *
 * `action` n'est pas optionnel par accident : un état vide qui se contente de
 * constater l'absence (« aucune offre ») laisse l'entreprise devant un écran mort.
 * Il doit porter le geste suivant, sinon il ne sert à rien.
 */
export function EmptyState({
	title,
	body,
	icon,
	action,
}: {
	title: string;
	body: string;
	icon?: ReactNode;
	action: ReactNode;
}) {
	return (
		<div className="flex flex-col items-center px-6 py-14 text-center">
			{icon ? (
				<span className="mb-4 inline-flex size-11 items-center justify-center rounded-full bg-mg-hover text-mg-action">
					{icon}
				</span>
			) : null}
			<h3 className="t-h4 text-mg-heading">{title}</h3>
			<p className="t-body mt-1.5 max-w-[46ch] text-mg-secondary">{body}</p>
			<div className="mt-5">{action}</div>
		</div>
	);
}
